



export const Bio = {
  name: "Sumit Tupe",
  roles: [
    "Web Developer",
    "Programmer",
    "Problem Solver"
  ],
  description:"I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Sumit9623",
  email:"mailto:sumittupe9623@gmail.com",
  resume:"https://drive.google.com/file/d/1lMhzcL6xhKmYwGNU3oXNU2FHnSF_RGHj/view",
  linkedin: "https://www.linkedin.com/in/sumit-tupe-8027a0241/",
  insta: "https://www.instagram.com/sumit_tupe_73/",
};

export const skills = [
  {
    title: "Launguges",
    skills: [
      {
        name: "C++",
        image:"https://raw.githubusercontent.com/isocpp/logos/64ef037049f87ac74875dbe72695e59118b52186/cpp_logo.svg"
      },
      {
        name: "JavaScript",
        image: "https://raw.githubusercontent.com/voodootikigod/logo.js/1544bdeed6d618a6cfe4f0650d04ab8d9cfa76d9/js.svg"
      }
    ]
  },
  {
    title: "Course work",
    skills: [
      {
        name: "Object Oriented Programming",
        // image:"https://raw.githubusercontent.com/isocpp/logos/64ef037049f87ac74875dbe72695e59118b52186/cpp_logo.svg"
      },
      {
        name: "DSA",
        // image:"https://camo.githubusercontent.com/651195b8c66a9dd22316e672992077dbcecea4ca904b45a6681558ebc0ecc517/68747470733a2f2f75706c6f61642e77696b696d656469612e6f72672f77696b6970656469612f656e2f7468756d622f332f33302f4a6176615f70726f6772616d6d696e675f6c616e67756167655f6c6f676f2e7376672f33303070782d4a6176615f70726f6772616d6d696e675f6c616e67756167655f6c6f676f2e7376672e706e67"
      },
      {
        name: "Database Management System",
        // image: "https://raw.githubusercontent.com/voodootikigod/logo.js/1544bdeed6d618a6cfe4f0650d04ab8d9cfa76d9/js.svg"
      }
    ]
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux Toolkit",
        image:
        "https://e7.pngegg.com/pngimages/522/1018/png-clipart-purple-atom-redux-logo-icons-logos-emojis-tech-companies-thumbnail.png"
      },

      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Tailwind CSS",
        image:
        "https://image.pngaaa.com/779/6447779-middle.png"
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image: "https://expressjs.com/images/express-facebook-share.png"
      },

      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    role: "Problem Setter - (freelance)",
    company: "iMocha",
    date: "Nov 2022 - Jan 2023",
    desc: "I worked as problem setter at iMocha where i have created some DSA related coding quetions. These quetions are used by organizations for coding assesments while campus hiring etc",
    skills: [
      "C++","DSA","Problem Solving"
    ],
    doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  }
];

export const education = [
  {
    id: 0,
    school: "Pune Institute of Computer Technology, Pune",
    date: "Aug 2020 - July 2024",
    grade: "8.96 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Electronics & Communications at Pune Institute of Computer Technology, Pune. I have completed 6 semesters and have a CGPA of 8.96. I have studied courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, among others.",
    degree: "Bachelor of Enginnering - B.E. Electronics & Telecommunications",
  },
  {
    id: 1,
    school: "Yashwantrao Chavan College of Science of Karad",
    date: "Apr 2018 - Apr 2020",
    grade: "89.37%",
    desc: "I completed my class 12 high school education at Yashwantrao Chavan College of Science of Karad, where I studied Science with Electronics.",
    degree: "HSC, Science (PCM)",
  },
  {
    id: 2,
    school: "Sadguru Gadage Maharaj Highschool Karad",
    date: "Apr 2018",
    grade: "91.80%",
    desc: "I completed my class 10th from Sadguru Gadage Maharaj Highschool Karad with 91.80%. Mathematics and Science are my favorite subjects.",
    degree: "SSC (10th)",

  },
];

export const projects = [
  {
    id: 10,
    title: "FashCart",
    date: "Feb 2023",
    description:
      "FashCart is full stack e-commerce website for a fashion. it has all nessesary functionality with great user experience.",
    image: "/FashCart_Image.png",
    tags: [
      "HTML","CSS/Tailwind CSS","JavaScript","React/Redux Toolkit", "NodeJS","ExpressJS","MongoDB Atlas",
    ],
    liveLink:"https://fash-cart-sumits-projects-a215df66.vercel.app",
    githubLink:"https://github.com/Sumit9623/FashCart"
  },
  {
    id: 9,
    title: "CineVerse",
    date: "Jun 2022",
    description:
      "Cineverse is a web application provide overall discription about the movies that leverage the TMDB API which have comprehensive collection of Movies.",
    image: "/CineVerse.png",
    tags: [
      "HTML","CSS","JavaScript","Responsive Design",
    ],
    liveLink:"https://sumit9623.github.io/CineVerse/",
    githubLink:"https://github.com/Sumit9623/CineVerse"
  }
];


